export type SpacingProps = {
  size?: SpacingSizes;
};

export enum SpacingSizes {
  L = "l",
  M = "m",
  S = "s",
  XL = "xl",
  XS = "xs",
  XXL = "xxl",
  XXS = "xxs",
  XXXL = "xxxl",
  XXXS = "xxxs",
}
